import styled from 'styled-components';

import { Icon as SemanticIcon } from 'semantic-ui-react';

export const CHART_HEIGHT = 350;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  position: relative;
  height: ${CHART_HEIGHT}px;
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const ChartContainer = styled.div`
  position: absolute;
  left: 25px;
  right: 25px;
`;

export const Icon = styled(SemanticIcon)`
  cursor: pointer;
`;
